export default __webpack_public_path__ + "static/media/hemant2.c20155d8.jpeg";